interface HandleClickOutsideProps {
  targetRef: React.RefObject<HTMLDivElement>
  setIndicesExpanded: React.Dispatch<React.SetStateAction<Set<number>>>
  event: MouseEvent
}

const handleClickOutside = ({
  targetRef,
  setIndicesExpanded,
  event,
}: HandleClickOutsideProps) => {
  const targetElement = targetRef?.current

  if (
    targetElement &&
    !targetElement?.contains(event?.target as Node) &&
    !(
      event?.target instanceof Element &&
      event?.target?.classList?.contains('js--outside-click')
    )
  ) {
    setIndicesExpanded(new Set([]))
  }
}

export default handleClickOutside
